import { observer } from 'mobx-react';
import React from 'react';

import DropIndicator from 'components/UI/DropIndicator';
import DrawerLayout from 'components/Views/Creative/Drawers/DrawerLayout';
import store from 'stores/RootStore';
import { PanelViews } from 'types/PanelViews';

import TemplatesDrawerHeader from './TemplatesDrawerHeader';
import TemplateSummaryRow from './TemplateSummaryRow';

function TemplatesDrawer() {
  const store_creative = store.creative;

  if (!store_creative) return null;

  const fileDragging = store.ui.fileDragging;
  const templates = [...store_creative.templates.children];

  const handleOnClose = () => {
    store_creative.setPanel(PanelViews.NONE);
  };

  return (
    <DrawerLayout
      onClose={handleOnClose}
      title={<TemplatesDrawerHeader />}
      open={store_creative.displayPanel === PanelViews.TEMPLATES}
    >
      <DropIndicator visible={fileDragging} />
      {templates.map((template) => (
        <TemplateSummaryRow key={template.id} template={template} />
      ))}
    </DrawerLayout>
  );
}

export default observer(TemplatesDrawer);
